export const POST_TAG = "POST_TAG"
export const POST_TAG_FAIL = "POST_TAG_FAIL"

export const POST_TAG_CATEGORY = "POST_TAG_CATEGORY"
export const POST_TAG_CATEGORY_FAIL = "POST_TAG_CATEGORY_FAIL"

export const FETCH_TAG = "FETCH_TAG"
export const FETCH_TAG_FAIL = "FETCH_TAG_FAIL"

export const PATCH_TAG = "PATCH_TAG"
export const PATCH_TAG_FAIL = "PATCH_TAG_FAIL"

export const PATCH_TAG_CATEGORY = "PATCH_TAG_CATEGORY "
export const PATCH_TAG_CATEGORY_FAIL  = "PATCH_TAG_CATEGORY_FAIL"

export const FETCH_TAG_CATEGORY = "FETCH_TAG_CATEGORY"
export const FETCH_TAG_CATEGORY_FAIL = "FETCH_TAG_CATEGORY_FAIL"

export const FETCH_ALL_TAG_CATEGORIES = "FETCH_ALL_TAG_CATEGORIES"
export const FETCH_ALL_TAG_CATEGORIES_FAIL = "FETCH_ALL_TAG_CATEGORIES_FAIL"


export const DELETE_TAG_CATEGORY = "DELETE_TAG_CATEGORY "
export const DELETE_TAG_CATEGORY_FAIL  = "DELETE_TAG_CATEGORY_FAIL"

export const DELETE_TAG = "DELETE_TA "
export const DELETE_TAG_FAIL  = "DELETE_TAG_FAIL"

export const LOADING_TAGS = "LOADING_TAGS"

export const CLEAR_STATUS_TAG = "CLEAR_STATUS_TAG"